import { Route, Routes, useNavigate,Navigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Home from "../components/Home";
import Footer from "../components/Footer";
import Login from "../components/Login"
import Signup from "../components/Signup"
import ProductList from "../components/productList"
import ProductDiscription from "../components/productDiscription"
import Checkout from "../pages/Checkout"
import Payment from "../pages/Payment"
import Cart from "../components/carts";
import OrderCompleted from "../components/checkout/OrderCompleted";
import Privateroutes from "./Privateroutes";
import { useSelector } from "react-redux";


export const Router = () => {
  const navigate=useNavigate();
  const Private = ({ children }) => {
    const token = localStorage.getItem("isLogged") || null;
    console.log(token);
    return token ? children : <Navigate to="/Login" /> ;
  };
  // const auth = useSelector((store) => store.authred);
  // console.log(auth)
  return (
    <>
      <Navbar />
      <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login/>} />
      <Route path="/signup" element={<Signup />} />
      <Route path='/allProducts' element={<ProductList/>}/>
      <Route path='/product/:id' element={<Private><ProductDiscription/></Private>}/>
      <Route path="/checkout" element={<Private><Checkout/></Private>} />
      <Route path="/payment" element={<Private><Payment /></Private>} />
      <Route path="/cart" element={<Private><Cart/></Private>} />
      <Route path="/success" element={<Private><OrderCompleted/></Private>} />
       </Routes>
      <Footer/>
    </>
  );
};
